import React, { useEffect, useState } from "react";
import "./Content.css";
import OurPackage from "./OurPackages";
import TestimonialNew from "./TestimonialNew";
import Blog from "./Blog";
import Gallery from "./Gallery.jsx";
import { Link } from "react-router-dom";
import microscope from "../../../Assets/newAsset/microscope.svg";
import health from "../../../Assets/newAsset/health.svg";
import dna from "../../../Assets/newAsset/dna.svg";

import research from "../../../Assets/newAsset/research.svg";
import cross from "../../../Assets/newAsset/cross.svg";
import HowItworks from "./HowItworks";
import ctscan from "../../../Assets/ctscan.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getPackageList } from "../../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import { AiTwotoneStar } from "react-icons/ai";

const pacakgesData = [
  {
    id: 1,
    img: cross,
    title: "Routine Testing",
    desc: "Routine investigations coverage from wellness to illness",
  },
  {
    id: 2,
    img: microscope,
    title: "Pathology Services",
    desc: "Super specialized department to diagnose auto immune disorders",
  },
  {
    id: 3,
    img: dna,
    title: "Genomic Testing",
    desc: "Advanced genetic testing to know your health risks",
  },
  {
    id: 4,
    img: ctscan,
    title: "Radiology",
    desc: "Advanced Medical Imaging procedures for your health diagnosis",
  },
];

// {
//   id: 4,
//   img: health,
//   title: "Affordable Packages",
//   desc: "We provide affordable packages",
// },
// {
//   id: 5,
//   img: research,
//   title: "Hormone testing",
//   desc: "Testing options to detect hormone imbalances",
// },

{
  /** */
}
//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Content({
  title,
  Ispackage,
  bgImg,
  isTestimonial,
  isBlog,
  isGallery,
  subheading,
  googleLogo,
}) {
  const [scrollPosition, setScrollPosition] = useState(0);

  //getting city selected
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  // const packageList = useSelector((state) => state.packageList);
  // const { loading, packages } = packageList;

  //CALLING ACTION FOR PACKAGE DATA
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getPackageList());
  // }, []);

  return (
    <div
      className={
        Ispackage ? "parentDivv parentDivNewPackageListing" : "testiParentDiv"
      }
    >
      <div
        className={
          Ispackage || isTestimonial || isBlog
            ? "childDiv childDivNewPackageListing  "
            : "childDiv  container"
        }
      >
        {isBlog || isGallery ? (
          <div className="divHeadingTesti divHeading divHeading2">
            <Link to="/blog">
              <span className="blog_link">{title}</span>
            </Link>
          </div>
        ) : Ispackage ? (
          <div className="HeaderDiv">
            <div className="divHeading">
              <h2>{title}</h2>
              <p> {subheading ? subheading : null}</p>
            </div>

            {/* <Link
              to={`/health-checkup-packages${
                citySelect
                  ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                  : ""
              }`}
            >
              View All
            </Link> */}
          </div>
        ) : (
          <div></div>
        )}

        {isGallery ? (
          <Gallery />
        ) : isBlog ? (
          <div className="PackParent">
            <Blog />
          </div>
        ) : isTestimonial ? (
          <TestimonialNew />
        ) : bgImg ? (
          <div className="HowItWorks__container">
            <LazyLoadImage
              src={
                "https://static.redcliffelabs.com/static/Assets/newAsset/howItWorks.png"
              }
              alt={
                "https://static.redcliffelabs.com/static/Assets/newAsset/howItWorks.png"
              }
              delayTime="100"
              defer
            />
            <HowItworks />
          </div>
        ) : Ispackage ? (
          <OurPackage />
        ) : (
          <>
            <div className="HeaderDiv">
              <div className="divHeading">
                <h2>Our Specialities </h2>
                <p> All Diagnostic Services Under One Roof</p>
              </div>
              <div className="divHeadingMob">
                <div className="upperReview">
                  <h2>Our Specialities </h2>
                </div>
                <p> All Diagnostic Services Under One Roof</p>
              </div>
            </div>
            <div className="PackParent">
              <div className="childDiv__content" id="childDiv__content">
                <div className="card__parentDiv" id="card__parentDiv">
                  {pacakgesData.map((values) => (
                    <div className="card__content" key={values.id}>
                      <div className="Card__mainContent">
                        <div className="card__img">
                          <img src={values.img} alt={values.img}></img>
                        </div>
                        <div className="card__bottomBar">
                          <div className="Newcard__title">
                            <span>{values.title}</span>
                          </div>
                          <div className="Newcard__desc">
                            <span>{values.desc}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/**div starts */}

        {/**div end */}
      </div>
    </div>
  );
}

export default Content;
